import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import isNil from 'lodash-es/isNil';

import { EmailValidationState } from './useEmailValidation';

export function useUpdateFormikStatus({
  emailValidationState,
}: {
  emailValidationState: EmailValidationState;
}) {
  const { setStatus, status } = useFormikContext();
  useEffect(() => {
    const statusServerErrors = status?.serverErrors ?? {};

    if (emailValidationState.status === 'idle' && status.emailValidationStatus !== 'idle') {
      setStatus({
        ...status,
        emailValidationStatus: 'idle',
        serverErrors: {
          ...statusServerErrors,
          email: null,
        },
      });
    } else if (
      emailValidationState.status === 'validated' &&
      status.emailValidationStatus === 'idle'
    ) {
      if (isNil(emailValidationState.error)) {
        setStatus({
          ...status,
          emailValidationStatus: 'valid',
          serverErrors: {
            ...statusServerErrors,
            email: null,
          },
        });
      } else {
        setStatus({
          ...status,
          emailValidationStatus: 'invalid',
          serverErrors: {
            ...statusServerErrors,
            email: emailValidationState.error,
          },
        });
      }
    }
  }, [emailValidationState.error, emailValidationState.status, setStatus, status]);
}
